import React from 'react'
import { Row, Divider, Form, Button, Statistic, Col, Select, Typography, DatePicker } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment'
import Segment from '../../components/Segment'
import API from '../../services/API'
import Search from '../../components/Search'
import { currencyFormat, method } from '../../services/Utils'

const { Paragraph } = Typography
const { Option } = Select
const { RangePicker } = DatePicker
const current = JSON.parse(localStorage.getItem('sucursal'))
const INIT = {
    createdAt: null,
    entryAt: null,
    totalInventory: 0,
    totalSales: 0,
    totalSalesPeriod: 0,
    productName: '',
    sales: [1, 2],
    labels: ['Enero', 'Febrero'],
}
//
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js'
import { Line } from 'react-chartjs-2'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Ventas en el año actual',
        },
    },
}

// const STATUS = ['En proceso', 'Cancelado', 'Enviado', 'Facturado']
const STATUS_OPTIONS = [
    { id: 1, name: 'En proceso' },
    { id: 2, name: 'Cancelado' },
    { id: 3, name: 'Enviado' },
    // { id: 4, name: 'Entregado' },
    { id: 5, name: 'Facturado' },
];

const ProductsRecordContainer = ({ match }) => {
    const [loading, setLoading] = React.useState(false)
    const [data, setData] = React.useState(INIT)
    const [finalData, setFinalData] = React.useState({
        labels: data.labels,
        datasets: [
            {
                label: data.productName,
                data: data.sales,
                borderColor: 'rgb(0, 75, 151)',
                backgroundColor: 'rgba(0, 75, 151, 0.5)',
            },
        ],
    })
    const [period, setPeriod] = React.useState('day');
    const [status, setStatus] = React.useState(3);

    const [dateRange, setDateRange] = React.useState({
        startDate: moment(),
        endDate: moment().add(1, 'days'),
    })
    const [subsidiary, setSubsidiary] = React.useState({
        id: current ? current.id : '',
        name: current ? current.name : '',
    })

    const getData = () => {
        setLoading(true)
        let query = '?'

        if (subsidiary.id) {
            query += `subsidiary_id=${subsidiary.id}`
        }

        if (period) {
            query += `&period=${period}`
        }

        if (status) {
            query += `&order_status_id=${status}`
        }

        if (dateRange.startDate && dateRange.endDate) {
            query += `&startDate=${dateRange.startDate.format('YYYY-MM-DD')}`
            query += `&endDate=${dateRange.endDate.format('YYYY-MM-DD')}`
        }

        API.get(`/api/products/${match.params.id}/record${query}`)
            .then(response => {
                setLoading(false)
                setData(response.data.payload)

                setFinalData({
                    labels: response.data.payload.labels,
                    datasets: [
                        {
                            label: response.data.payload.productName,
                            data: response.data.payload.sales,
                            borderColor: 'rgb(0, 75, 151)',
                            backgroundColor: 'rgba(0, 75, 151, 0.5)',
                        },
                    ],
                })
            })
            .catch(error => {
                setLoading(false)
                console.error(error)
            })
    }

    React.useEffect(() => {
        getData()
    }, [])

    React.useEffect(() => {
        getData()
    }, [dateRange, subsidiary.id, status])

    return (
        <Segment loading={loading}>
            <Divider>Historial producto</Divider>
            <Form style={{ maxWidth: '800px', margin: 'auto' }} className="form-border">
                <Row gutter={24}>
                    <Col lg={6} md={12} sm={24}>
                        <Form.Item label="Sucursal">
                            <Search
                                value={subsidiary.name}
                                placeholder="Sucursal"
                                onSearch={value => `/api/subsidiaries?filter[active]&filter[name]=${value}`}
                                onChange={(key, value) => {
                                    setSubsidiary(value)
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={6} md={12} sm={24}>
                        <Form.Item label="Periodo">
                            <Select
                                style={{ width: '100%' }}
                                value={period}
                                onChange={(key, value) => {
                                    switch (key) {
                                        case 'day':
                                            setDateRange({
                                                startDate: moment(),
                                                endDate: moment().add(1, 'days'),
                                            })
                                            break
                                        case 'week':
                                            setDateRange({
                                                startDate: moment().startOf('week'),
                                                endDate: moment().endOf('week'),
                                            })
                                            break
                                        case 'month':
                                            setDateRange({
                                                startDate: moment().startOf('month'),
                                                endDate: moment().endOf('month'),
                                            })
                                            break
                                        case 'year':
                                            setDateRange({
                                                startDate: moment().startOf('year'),
                                                endDate: moment().endOf('year'),
                                            })
                                            break
                                        default:
                                            break
                                    }

                                    setPeriod(key)
                                }}
                                placeholder="Periodo"
                            >
                                <Option key="day" value="day">
                                    Día actual
                                </Option>
                                <Option key="week" value="week">
                                    Semana actual
                                </Option>
                                <Option key="month" value="month">
                                    Mes actual
                                </Option>
                                <Option key="year" value="year">
                                    Año actual
                                </Option>
                                <Option key="custom" value="custom">
                                    Personalizado
                                </Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col lg={6} md={12} sm={24}>
                        <Form.Item label="Estatus">
                            <Select value={status} onChange={setStatus} placeholder="Status">
                                {STATUS_OPTIONS.map((item) => (
                                    <Option key={item.id} value={item.id}>
                                        {item.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col lg={6} md={12} sm={24}>
                        {period == 'custom' ? (
                            <Form.Item label="Rango de fechas">
                                <RangePicker
                                    value={[dateRange.startDate, dateRange.endDate]}
                                    onChange={dateRange => {
                                        setDateRange({
                                            startDate: dateRange[0],
                                            endDate: dateRange[1],
                                        })
                                    }}
                                />
                            </Form.Item>
                        ) : null}
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={5}>
                        <Statistic
                            title="Fecha de creación de producto"
                            value={data.createdAt ? moment(data.createdAt, 'YYYY/MM/DD').format('DD/MM/YYYY') : '-'}
                            loading
                        />
                    </Col>

                    <Col span={5}>
                        <Statistic
                            title="Fecha actualización Inventario"
                            value={data.entryAt ? moment(data.entryAt, 'YYYY/MM/DD').format('DD/MM/YYYY') : ''}
                            loading
                        />
                    </Col>

                    <Col span={5}>
                        <Statistic
                            title="Fecha de última actualización"
                            value={data.updatedAt ? moment(data.updatedAt, 'YYYY/MM/DD').format('DD/MM/YYYY') : ''}
                            loading
                        />
                    </Col>

                    <Col span={4}>
                        <Statistic title="Total vendidos" value={data.totalSales} loading />
                    </Col>

                    <Col span={4}>
                        <Statistic title="Total existencia" value={data.totalInventory} loading />
                    </Col>
                </Row>
                <Divider />
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Paragraph strong>Vendidos en el periodo selecionado ({data.totalSalesPeriod})</Paragraph>
                </div>
                {console.log(finalData)}
                <Line options={options} data={finalData} />
            </Form>
            <Row type="flex" justify="center" style={{ marginTop: '50px' }}>
                <Form.Item>
                    <Link to="/products" style={{ marginLeft: '5px' }}>
                        <Button icon="arrow-left">Regresar</Button>
                    </Link>
                </Form.Item>
            </Row>
        </Segment>
    )
}

export default ProductsRecordContainer
